import asyncComponent from './asyncComponent'
import React, { Suspense } from 'react'
import { Redirect, Switch } from 'react-router'
import { Route } from 'react-router-dom'
import { setRedirectUrl } from 'helpers/manageCookies';
import Layout from 'layout';

// Lazy loaded components goes here.
const MeetingRoutes = asyncComponent(() => {
	return import('./chunks/meeting.chunk')
})
export const AppRoutes = (props) => {
	if (props && props.location ) {
        const { pathname, search } = props.location;
        if (pathname  && !props.isSignOutTrigger && (props.isMemberStillLoginInAnotherTab !== "false")) {
            const path = pathname + search;
            setRedirectUrl(path);
        }
    }
	return(
	<Layout {...props}>
		<Suspense fallback={() => { 'Loading...' }}>
			<Switch>
				{<Redirect exact from='/' to='/meeting' />}
				<Route path='/meeting' component={MeetingRoutes} />
			</Switch>
		</Suspense>
	</Layout>
	)
}

export default AppRoutes
